export default __webpack_public_path__ + "static/media/cover.c4daf77c.jpg";